import script from "./TitleDetailedCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TitleDetailedCard.vue?vue&type=script&setup=true&lang=js"

import "./TitleDetailedCard.vue?vue&type=style&index=0&id=3410ec0a&lang=scss"

const __exports__ = script;

export default __exports__